<template>
  <div class="pay-success">
    <div class="success-box">
      <div class="success-icon">
        <i class="el-icon-circle-check"></i>
      </div>
      <div class="success-title">{{ type === 'transfer' ? '转账信息已提交' : '支付信息已提交，请等待审核通过！' }}</div>

      <!-- 在线支付 -->
      <div class="success-desc" v-if="type === 'online'">
        <p>服务开通后，可立即登录账号查阅对应栏目资讯内容。</p>
        <p class="period" v-if="open_time && expire_time">您的服务有效期：{{ open_time }} - {{ expire_time }}</p>
        <p class="tip-refresh">如仍看到「会员专享」提示，请刷新页面或重新登录后查看。</p>
        <p>如需开具发票，请联系客服：13396040230（赵女士微信同号）；bolancaijing@bolanjr.com</p>
      </div>

      <!-- 银行转账 -->
      <div class="success-desc" v-else>
        <p>我们将在1个工作日内核对银行到账情况，款项到账后自动开通服务。</p>
        <p>您可在「个人中心-我的订单」中查看订单状态与到账进度。</p>
        <p>超过7个工作日款项未到账的，订单自动关闭，您可重新下单。</p>
        <p>客服工作时间：周一至周五9:00-17:30（法定节假日除外）。</p>
        <p>如有疑问可联系客服：13396040230（赵女士微信同号）</p>
      </div>

      <!-- 新注册账号信息 -->
      <div class="account-box" v-if="account.username">
        <div class="account-title">您的账号信息（请妥善保存）</div>
        <div class="account-info">
          <div class="account-item"><span class="label">用户名：</span><span class="value">{{ account.username }}</span></div>
          <div class="account-item"><span class="label">登录密码：</span><span class="value">{{ account.password }}</span></div>
          <div class="account-item"><span class="label">手机号：</span><span class="value">{{ account.phone }}</span></div>
        </div>
        <div class="account-tip">
          <i class="el-icon-warning"></i>
          系统已为您自动登录，请牢记上述账号信息。建议登录后及时修改密码。
        </div>
        <div class="account-actions">
          <el-button size="small" type="primary" @click="downloadAccount">下载账号信息</el-button>
        </div>
      </div>

      <div class="action-bar">
        <el-button type="primary" class="btnBg" @click="goHome">返回首页</el-button>
        <el-button @click="goUCenter">个人中心</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaySuccess",
  data() {
    return {
      type: this.$route.query.type || 'online',
      open_time: this.$route.query.open_time || '',
      expire_time: this.$route.query.expire_time || '',
      order_id: this.$route.query.order_id || '',
      account: { username: '', password: '', phone: '', token: '' },
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    // 读取自动注册的账号信息
    this.loadAccount();
    if (this.type === 'online' && this.order_id && (!this.open_time || !this.expire_time)) {
      this.queryOrder();
    }
  },
  methods: {
    loadAccount() {
      const raw = sessionStorage.getItem('newAccount');
      if (raw) {
        try {
          const obj = JSON.parse(raw);
          this.account = obj;
          // 自动登录：写入 token 和 username 到 localStorage
          if (obj.token) {
            window.localStorage.setItem('token', obj.token);
          }
          if (obj.username) {
            window.localStorage.setItem('username', obj.username);
          }
          if (obj.phone) {
            window.localStorage.setItem('phone', obj.phone);
          }
          // 清除 sessionStorage
          sessionStorage.removeItem('newAccount');
        } catch (e) {
          console.log('parse newAccount error', e);
        }
      }
    },
    downloadAccount() {
      const content = `博览财经 - 账号信息\n\n用户名：${this.account.username}\n登录密码：${this.account.password}\n手机号：${this.account.phone}\n\n请妥善保管您的账号信息。\n建议登录后及时修改密码。\n\n生成时间：${new Date().toLocaleString()}`;
      const blob = new Blob([content], {type: 'text/plain;charset=utf-8'});
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = '账号信息_' + this.account.username + '.txt';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    queryOrder() {
      import('@/api/order').then(({ payStatus }) => {
        payStatus({order_id: this.order_id}).then((response) => {
          if (response && (response.code === 2000 || response.code === 200) && response.data) {
            if (response.data.open_time) this.open_time = response.data.open_time;
            if (response.data.expire_time) this.expire_time = response.data.expire_time;
          }
        }).catch(() => {});
      });
    },
    goHome() {
      this.$router.push({path: '/'});
    },
    goUCenter() {
      this.$router.push({path: '/UCenter', query: {tab: 'second'}});
    },
  }
}
</script>

<style scoped>
.pay-success {
  width: 1200px;
  margin: 50px auto 40px;
}
.success-box {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 60px 40px;
  text-align: center;
}
.success-icon {
  margin-bottom: 20px;
}
.success-icon i {
  font-size: 80px;
  color: #52c41a;
}
.success-title {
  font-size: 24px;
  font-weight: 600;
  color: #001646;
  margin-bottom: 24px;
}
.success-desc {
  font-size: 15px;
  line-height: 30px;
  color: #595959;
  margin-bottom: 30px;
}
.success-desc p {
  margin-bottom: 4px;
}
.success-desc .period {
  color: #d4380d;
  font-weight: 600;
  margin: 8px 0;
}
.success-desc .tip-refresh {
  color: #fa8c16;
  font-size: 13px;
  margin: 6px 0;
}
.account-box {
  background: #f0f5ff;
  border: 1px solid #d6e4ff;
  border-radius: 6px;
  padding: 20px 24px;
  margin: 20px auto 30px;
  max-width: 500px;
  text-align: left;
}
.account-title {
  font-size: 16px;
  font-weight: 600;
  color: #001646;
  margin-bottom: 14px;
  text-align: center;
}
.account-item {
  font-size: 15px;
  line-height: 32px;
  color: #303133;
}
.account-item .label {
  color: #898989;
  display: inline-block;
  width: 90px;
}
.account-item .value {
  color: #001646;
  font-weight: 600;
}
.account-tip {
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 13px;
  color: #d4380d;
  line-height: 22px;
  margin-top: 12px;
}
.account-tip i {
  margin-right: 4px;
}
.account-actions {
  text-align: center;
  margin-top: 14px;
}
.action-bar {
  text-align: center;
}
>>> .action-bar .el-button {
  width: 180px;
  height: 44px;
  font-size: 15px;
  margin: 0 12px;
}
>>> .btnBg {
  background-color: #001646 !important;
  border-color: #001646 !important;
}
>>> .btnBg:hover,
>>> .btnBg:focus {
  background-color: #0a2a6e !important;
  border-color: #0a2a6e !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PaySuccess.vue